const STORAGE_KEY = 'flea_checkout_idempotency_key';

export function getCheckoutIdempotencyKey(reset = false) {
  if (typeof window === 'undefined') {
    return null;
  }
  if (reset) {
    const key = crypto.randomUUID();
    window.sessionStorage.setItem(STORAGE_KEY, key);
    return key;
  }
  let key = window.sessionStorage.getItem(STORAGE_KEY);
  if (!key) {
    key = crypto.randomUUID();
    window.sessionStorage.setItem(STORAGE_KEY, key);
  }
  return key;
}

export function resetCheckoutIdempotencyKey() {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function checkoutIdempotencyHeaders(reset = false) {
  const key = getCheckoutIdempotencyKey(reset);
  return key ? { 'Idempotency-Key': key } : {};
}
